import { Card, CardHeader, Row, Col } from "reactstrap";

const TokensStatsCards = ({ tokensData }) => {
    const totalTokens = tokensData.length;
    const activeTokens = tokensData.filter((token) => !token.isDeleted).length;
    const mainnetTokens = tokensData.filter((token) => token.isMainnet).length;
    const highestPrice =
        tokensData.length > 0
            ? Math.max(...tokensData.map((token) => token.price || 0))
            : 0;

    const statsConfig = [
        {
            title: "Total Tokens",
            value: totalTokens,
            icon: "fas fa-coins",
            bgColor: "bg-primary",
        },
        {
            title: "Active Tokens",
            value: activeTokens,
            icon: "fas fa-check-circle",
            bgColor: "bg-success",
        },
        {
            title: "Mainnet Tokens",
            value: mainnetTokens,
            icon: "fas fa-network-wired",
            bgColor: "bg-info",
        },
        {
            title: "Highest Price",
            value: `$${highestPrice.toLocaleString()}`,
            icon: "fas fa-dollar-sign",
            bgColor: "bg-warning",
        },
    ];

    return (
        <Row className="mb-4">
            {statsConfig.map((stat, index) => (
                <Col xl="3" lg="6" key={index}>
                    <Card className="card-stats mb-4 mb-xl-0">
                        <CardHeader>
                            <Row>
                                <div className="col">
                                    <h5 className="card-title text-uppercase text-muted mb-0">
                                        {stat.title}
                                    </h5>
                                    <span className="h2 font-weight-bold mb-0">
                                        {stat.value}
                                    </span>
                                </div>
                                <div className="col-auto">
                                    <div
                                        className={`icon icon-shape ${stat.bgColor} text-white rounded-circle shadow`}
                                    >
                                        <i className={stat.icon} />
                                    </div>
                                </div>
                            </Row>
                        </CardHeader>
                    </Card>
                </Col>
            ))}
        </Row>
    );
};

export default TokensStatsCards;
